import type { MailingLanguageCode, NewsroomLanguageCode } from '@zimpel/common/config';

export const defaultLanguageCode: MailingLanguageCode = 'de';
export const defaultNewsroomLanguageCode: NewsroomLanguageCode = 'de';

export const newsroomLanguageCodeToIdMap: Record<NewsroomLanguageCode, number> = {
  'de': 1,
  'en': 2,
  'fr': 3,
  'it': 4,
  'nl': 5,
  'es': 6,
  'pt': 7,
};
